const translate = {
    name: "translate",
    path: "/translate",
    title: "translate",
    description: "Utilities for controlling the CSS translate property.",
    value: {
        "translate": {
            "translate-<number>": "var(--uni-translate-x) var(--uni-translate-y)",
            "-translate-<number>": "-var(--uni-translate-x) -var(--uni-translate-y)",
            "translate-<fraction>":"calc(<fraction> * 100%) calc(<fraction> * 100%)",
            "-translate-<fraction>":"calc(-<fraction> * 100%) calc(-<fraction> * 100%)",
            "translate-full": "100%",
            "-translate-full": "-100%",
            "translate-px": "1px 1px",
            "-translate-px": "-1px -1px",
            "translate-[<value>]":"<value> <value>",
            "translate-x-<number>": "var(--uni-translate-x) var(--uni-translate-y)",
            "-translate-x-<number>": "-var(--uni-translate-x) var(--uni-translate-y)",
            "translate-x-<fraction>": "calc(<fraction> * 100%) var(--uni-translate-y)",
            "-translate-x-<fraction>": "calc(-<fraction> * 100%) var(--uni-translate-y)",
            "translate-x-full": "100% var(--uni-translate-y)",
            "-translate-x-full": "-100% var(--uni-translate-y)",
            "translate-y-<number>": "var(--uni-translate-x) var(--uni-translate-y)",
            "-translate-y-<number>": "var(--uni-translate-x) -var(--uni-translate-y)",
            "-translate-x-px": "-1px var(--uni-translate-y)",
            "translate-x-px": "1px var(--uni-translate-y)",
            "translate-y-<fraction>": "var(--uni-translate-x) calc(<fraction> * 100%)",
            "-translate-y-<fraction>": "var(--uni-translate-x) calc(-<fraction> * 100%)",
            "translate-y-full": "var(--uni-translate-x) 100%",
            "-translate-y-full": "var(--uni-translate-x) -100%",
            "-translate-y-px": "var(--uni-translate-x) -1px",
            "translate-y-px": "var(--uni-translate-x) 1px",
            "translate-z-<number>": "var(--uni-translate-x) var(--uni-translate-y) var(--uni-translate-z)",
            "-translate-z-<number>": "-var(--uni-translate-x) -var(--uni-translate-y) -var(--uni-translate-z)",
            "translate-z-px": "var(--uni-translate-x) var(--uni-translate-y) 1px",
            "-translate-z-px": "-var(--uni-translate-x) -var(--uni-translate-y) -1px",
            "translate-none": "none",
        }
    },
    exampleData: [
        {
            example: {
                code: `<img class="-translate-6 ..." src="/img/mountains.jpg" />
<img class="translate-2 ..." src="/img/mountains.jpg" />
<img class="translate-8 ..." src="/img/mountains.jpg" />
<img class="translate-[10%_50%] ..." src="/img/mountains.jpg" />`
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-*</code> utilities to translate an element on both axes based on the spacing scale:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-translate-6</span>
          <div class="relative">
            <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-translate-6 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
          </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-2</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-2 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-8</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-8 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-[]</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-[10%_50%] size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-<var>&lt;fraction&gt;</var></code>
        utilities like translate-1/4 and -translate-full to translate an element on both axes by a percentage of the element's size:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-translate-1/4</span>
          <div class="relative">
            <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-translate-1/4 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
          </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-1/6</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-1/6 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-1/2</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-1/2 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use
        <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-x-<var>&lt;number&gt;</var></code> or 
        <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-x-<var>&lt;fraction&gt;</var></code>
        utilities like translate-x-4 and translate-x-1/4 to translate an element on the x-axis:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-translate-x-4</span>
          <div class="relative">
            <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-translate-x-4 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
          </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-x-2</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-x-2 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-x-1/2</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-x-1/2 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use
        <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-y-<var>&lt;number&gt;</var></code> or 
        <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-y-<var>&lt;fraction&gt;</var></code>
        utilities like translate-y-4 and translate-y-1/4 to translate an element on the x-axis:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-translate-y-4</span>
          <div class="relative">
            <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-translate-y-4 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
          </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-y-2</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-y-2 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">translate-y-1/2</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="translate-y-1/2 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use
        <code class="text-color-gray-800 dark:text-color-white font-semibold">translate-z-<var>&lt;number&gt;</var></code>        utilities like translate-z-4 and translate-z-1/4 to translate an element on the z-axis:
      </p>
      <div class="flex shrink-0 items-center justify-around gap-4 p-8">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-xs text-color-gray-500">-translate-z-8</p>
            <div class="relative rotate-x-50 rotate-z-45 transform-style-3d">
                <div class="absolute inset-0 overflow-y-hidden rounded-lg backdrop-blur-sm">
                <img class="size-24 object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"></div>
                <div class="relative z-10 -translate-z-8">
                    <img class="size-24 rounded-lg object-cover shadow-xl" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo">
                    <div class="absolute inset-0 rounded-lg ring-1 ring-color-black/10 ring-inset"></div>
                </div>
            </div>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-xs text-color-gray-500">translate-z-4</p>
            <div class="relative rotate-x-50 rotate-z-45 transform-style-3d">
                <div class="absolute inset-0 overflow-y-hidden rounded-lg"><img class="size-24 object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"></div>
                <div class="relative z-10 translate-z-4">
                    <img class="size-24 rounded-lg object-cover shadow-xl" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo">
                    <div class="absolute inset-0 rounded-lg ring-1 ring-color-black/10 ring-inset"></div>
                </div>
            </div>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-xs text-color-gray-500">translate-z-12</p>
            <div class="relative rotate-x-50 rotate-z-45 transform-style-3d">
                <div class="absolute inset-0 overflow-y-hidden rounded-lg"><img class="size-24 object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"></div>
                <div class="relative z-10 translate-z-12">
                    <img class="size-24 rounded-lg object-cover shadow-xl" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo">
                    <div class="absolute inset-0 rounded-lg ring-1 ring-color-black/10 ring-inset"></div>
                </div>
            </div>
        </div>
        </div>
      `
        },
    ]
};

export default translate;
<div className="translate-x-1/2 translate-x-2 -translate-x-4 translate-y-1/2 translate-y-2 -translate-y-4 -translate-6 translate-2 translate-8 translate-[10%_50%] translate-1/2 translate-1/6 -translate-1/4">

<div class="flex shrink-0 items-center justify-around gap-4 p-8">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-xs text-color-gray-500">-translate-z-8</p>
            <div class="relative rotate-x-50 rotate-z-45 transform-style-3d">
                <div class="absolute inset-0 overflow-y-hidden rounded-lg backdrop-blur-sm">
                <img class="size-24 object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/></div>
                <div class="relative z-10 -translate-z-8">
                    <img class="size-24 rounded-lg object-cover shadow-xl" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
                    <div class="absolute inset-0 rounded-lg ring-1 ring-color-black/10 ring-inset"></div>
                </div>
            </div>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-xs text-color-gray-500">translate-z-4</p>
            <div class="relative rotate-x-50 rotate-z-45 transform-style-3d">
                <div class="absolute inset-0 overflow-y-hidden rounded-lg"></div>
                <div class="relative z-10 translate-z-4">
                    <div class="absolute inset-0 rounded-lg ring-1 ring-color-black/10 ring-inset"></div>
                </div>
            </div>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-10 text-xs text-color-gray-500">translate-z-12</p>
            <div class="relative rotate-x-50 rotate-z-45 transform-style-3d">
                <div class="absolute inset-0 overflow-y-hidden rounded-lg"></div>
                <div class="relative z-10 translate-z-12">
                    <div class="absolute inset-0 rounded-lg ring-1 ring-color-black/10 ring-inset"></div>
                </div>
            </div>
        </div>
        </div></div>